import { DEFAULT_API_CONFIG } from './apiConfig';
import { createNewUserWithRole } from './account.service';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/qa`;
const baseAccountRoute = `${url}/account`;

export const getAllQaUsers = async () => {
  const url = `${baseRoute}/users`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getQaUserById = async id => {
  const url = `${baseRoute}/users/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getMyQaProfile = async () => {
  const url = `${baseRoute}/me`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getQaUserOptions = async () => {
  const url = `${baseRoute}/options`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getQaTimeTrackingData = async (opts = {}) => {
  const q = queryString.stringify(opts);
  const url = `${baseRoute}/TimeTracking?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const createQaUser = async user => {
  user.role = 'QA';
  const url = `${baseAccountRoute}/RegisterUser`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const putQaUser = async user => {
  user.role = 'QA';
  const url = `${baseAccountRoute}/UpdateUser`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const saveQAProfile = async qa => {
  const createMode = !qa.qaId;

  const url = createMode ? `${baseRoute}/QAProfile` : `${baseRoute}/${qa.qaId}/QAProfile`;

  const method = createMode ? 'POST' : 'PUT';

  let headers = getHeaders();
  const response = await fetch(url, {
    method,
    body: JSON.stringify(qa),
    headers,
  });

  if (response.ok) {
    return true;
  }

  const json = await response.json();
  return Promise.reject(json);
};

export const isUserAuthorizedToViewClient = async clientId => {
  const url = `${baseRoute}/UserClientAuth/${clientId}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const orderManipulationRejectCancelledOrder = async oc => {
  const url = `${baseRoute}/RejectCancelledOrder`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(oc),
  });
  return response.ok ? response : Promise.reject(response);
};


